import React, { useEffect, useState } from "react";
import CommonModal from "components/modules/layout/CommonModal";
import { useQuery } from "@tanstack/react-query";
import useExamRoomActions from "api/hooks/admin/examRoom";
import Modal from "../../../modules/layout/Modal";
import dayjs from "dayjs";

const ResultLogModal = ({ userSn, isOpen, setIsOpen }) => {
  const { getExamLog } = useExamRoomActions();
  const { data: getExamLogList } = useQuery({
    queryKey: ["getExamLog", userSn],
    queryFn: () => getExamLog({ tester_sn: userSn }),
    onSuccess: (res) => {
      // console.log(res);
    },
  });

  // console.log("getExamLogList", getExamLogList);
  return (
    <Modal isOpen={isOpen}>
      <div className="modal fade" style={{ display: "block" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header flex">
              <p className="sign-top-title" id="staticBackdropLabel">
                응시로그
              </p>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => setIsOpen(false)}
              ></button>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>응시 로그</p>
              </div>
              <div className="modal-cont overflow-scroll height-670">
                <div className="log-border-box flex">
                  <span className="log-line"></span>
                  <div className="log-img time"></div>
                  <div className="log-txt-box">
                    {/* <p>요청 : 2022-08-18 16:08:26(EMAIL@naver.com) 확인지점2</p> */}
                    {/* <p>처음시작: 2022-08-19 14:15:12 확인지점3</p> */}
                    <p>
                      {/* 기종: Mozilla/5.0 (Windows NT 10.0; Win64; x64) 확인지점4 */}
                    </p>
                    <p>
                      {/* AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Sa 확인지점5 */}
                    </p>
                    <p>버전: </p>
                  </div>
                </div>
                {getExamLogList?.data?.map((aaa, bbb) => (
                  <div className="log-border-box flex" key={bbb}>
                    <span className="log-line"></span>
                    <div className="log-img check"></div>
                    <div className="log-txt-box">
                      <p className="q-num">{bbb + 1}번 응답.</p>
                      <p>
                        시작:{" "}
                        {dayjs(aaa.createtime).format("YYYY-MM-DD HH:mm:ss")}
                      </p>
                      <p>
                        {/* 업로드 시작: 2022-08-19 14:16:03 (0 Kbyte) 확인지점9 */}
                      </p>
                      <p>
                        {/* 업로드 종료 : 2022-08-19 14:16:03 (2612 Kbyte) 확인지점10 */}
                      </p>
                    </div>
                  </div>
                ))}
                {/* <div className="log-border-box flex">
                  <span className="log-line"></span>
                  <div className="log-img check"></div>
                  <div className="log-txt-box">
                    <p className="q-num">4번 응답.</p>
                    <p>시작: 2022-08-19 14:15:12</p>
                    <p>업로드 시작: 2022-08-19 14:16:03 (0 Kbyte)</p>
                    <p>업로드 종료 : 2022-08-19 14:16:03 (2612 Kbyte)</p>
                  </div>
                </div> */}
              </div>
              <div className="modal-footer text-align-right">
                <button
                  type="button"
                  className="modal-btn modal-close-btn"
                  onClick={() => setIsOpen(false)}
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ResultLogModal;
